import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/auth/guards/auth.guard';
import { CoreComponent } from './core.component';

const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: '', component: CoreComponent, children: [
            { path: 'home', loadChildren: () => import('../features/home/home.module').then(m => m.HomeModule) },
            { path: 'data-visualization', loadChildren: () => import('../features/data-visualization/data-visualization.module').then(m => m.DataVisualizationModule) },
            { path: 'user', loadChildren: () => import('../features/user/user.module').then(m => m.UserModule) },
            { path: 'favorites', loadChildren: () => import('../features/favorites/favorites.module').then(m => m.FavoritesModule) },
            { path: 'tasks', loadChildren: () => import('../features/tasks/tasks.module').then(m => m.TasksModule) },
            { path: 'admin', loadChildren: () => import('../features/admin/admin.module').then(m => m.AdminModule) },
            { path: 'help', loadChildren: () => import('../features/help/help.module').then(m => m.HelpModule) },
            { path: 'chat', loadChildren: () => import('../features/chat-gen-ia-page/chat-gen-ia.module').then(m => m.ChatGenIAModule) },
        ], canActivate: [AuthGuard]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CoreRoutingModule { }